import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoTratamentoAguaEnum } from 'graphql/types.generated'

import { tipoTratamentoAguaEnumRecord, tipoTratamentoAguaValidoEnumList } from './condicoes-moradia-model'

export type TipoTratamentoAguaSelectFieldProps = CustomSelectFieldProps<TipoTratamentoAguaEnum> & {
  showItensLegados: boolean
}

export function TipoTratamentoAguaSelectField(props: TipoTratamentoAguaSelectFieldProps) {
  const items = props.showItensLegados ? allItems : tipoTratamentoAguaValidoEnumList
  return <SelectField<TipoTratamentoAguaEnum> items={items} itemToString={itemToString} {...props} />
}

const allItems = Object.values(TipoTratamentoAguaEnum)
const itemToString = (item: TipoTratamentoAguaEnum) => item && tipoTratamentoAguaEnumRecord[item]
